import { shuffle } from "./shuffle"

/**
 * Returns a random sample of n elements from an array
 */
export const sample = <T>(array: T[], n: number = 1): T[] => {
  if (n >= array.length) return shuffle(array)

  const shuffled = shuffle(array)
  return shuffled.slice(0, n)
}
